
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {
name: "settinglogs",
components: {XTable, CheckIcon},
data() {
return {
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
isLeader: false,
isName: false,
visiableName: '',
userList: [],
userTotal: 0,
visiableUser: [],
date: '',
visiableUserid: ''
}
},
methods: {
submit(bool, userid) {
userid = userid ? userid : this.visiableUserid
if (!userid) {
this.$vux.alert.show({
title: '',
content: '请选择日志可见人'
})
return;
}
let time;
try {
time = bool ? this.date : '1970-01-01';
} catch (e) {
time = '1970-01-01';
}
if (this.isLeader) {
if (confirm('设置直属领导后，原设置将会被覆盖，是否继续？'))
this.$http.get('/api/v1/sale_logs/config_my_salelog?src=' + localStorage.getItem('userid') + '&tag=' + userid +
'&add=' + bool + '&start=' + time + '&is_leader=' + this.isLeader, this.header).then(() => {
this.getUserList();
this.$vux.alert.show({
title: '',
content: '设置成功'
})
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
} else {
this.$http.get('/api/v1/sale_logs/config_my_salelog?src=' + localStorage.getItem('userid') + '&tag=' + userid +
'&add=' + bool + '&start=' + time + '&is_leader=' + this.isLeader, this.header).then(() => {
this.getUserList();
this.$vux.alert.show({
title: '',
content: '设置成功'
})
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
}
},
changeDate() {
this.$vux.datetime.show({
value: this.date, // 其他参数同 props
confirmText: '确定',
cancelText: '取消',
onConfirm: (event) => {
this.date = event
}
})
},
choseVisiable(value) {
this.visiableName = value.name
this.visiableUserid = value.userid
this.isName = false
},
getVisiableUser(event) {
const value = event ? event.target.value : ''
this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=' + value, this.header).then(response => {
this.visiableUser = response.data
this.isName = event
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
},
getUserList() {
this.$http.get('/api/v1/sale_logs/get_salelog_config?userid=' + localStorage.getItem('userid') + '&offset=0&count=10', this.header).then(response => {
this.userList = response.data['content'];
this.userTotal = response.data['total'];
}).catch(error => {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
})
}
},
created() {
this.getVisiableUser('')
this.getUserList()
}
}



// WEBPACK FOOTER //
// ./src/components/Saleslog/settinglogs.vue